export default __webpack_public_path__ + "static/media/tip18.a8e18382.png";